import { REQUEST_PROFILE_TAB_EMAILS_MASS_ACTION } from '../../RequestProfileTabEmails.constants'

export function getRequestProfileTabEmailsMassActionsNotificationTitleKey(
  action
) {
  const keys = {
    [REQUEST_PROFILE_TAB_EMAILS_MASS_ACTION.Delete]:
      'RequestProfile.TabEmailsMassDeleteSuccessKey',
    [REQUEST_PROFILE_TAB_EMAILS_MASS_ACTION.MarkAsRead]:
      'RequestProfile.TabEmailsMassMarkAsReadSuccessKey',
    [REQUEST_PROFILE_TAB_EMAILS_MASS_ACTION.MarkAsStarred]:
      'RequestProfile.TabEmailsMassMarkAsStarredSuccessKey',
    [REQUEST_PROFILE_TAB_EMAILS_MASS_ACTION.MarkAsUnread]:
      'RequestProfile.TabEmailsMassMarkAsUnreadSuccessKey',
    [REQUEST_PROFILE_TAB_EMAILS_MASS_ACTION.MarkAsUnstarred]:
      'RequestProfile.TabEmailsMassMarkAsUnstarredSuccessKey',
  }

  return keys[action] || null
}

export function getRequestProfileTabEmailsMassActionsErrorTitleKey(action) {
  const keys = {
    [REQUEST_PROFILE_TAB_EMAILS_MASS_ACTION.Delete]:
      'RequestProfile.TabEmailsDeleteErrorKey',
    [REQUEST_PROFILE_TAB_EMAILS_MASS_ACTION.MarkAsRead]:
      'RequestProfile.TabEmailsMarkAsReadErrorKey',
    [REQUEST_PROFILE_TAB_EMAILS_MASS_ACTION.MarkAsStarred]:
      'RequestProfile.TabEmailsMarkAsStarredErrorKey',
    [REQUEST_PROFILE_TAB_EMAILS_MASS_ACTION.MarkAsUnread]:
      'RequestProfile.TabEmailsMarkAsUnreadErrorKey',
    [REQUEST_PROFILE_TAB_EMAILS_MASS_ACTION.MarkAsUnstarred]:
      'RequestProfile.TabEmailsMarkAsUnstarredErrorKey',
  }

  return keys[action] || null
}
